
import React from 'react';
import { Camera, Film } from 'lucide-react';

interface CategoryToggleProps {
  activeCategory: 'photos' | 'films';
  setActiveCategory: (category: 'photos' | 'films') => void;
}

const CategoryToggle: React.FC<CategoryToggleProps> = ({ activeCategory, setActiveCategory }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="bg-elegant-100 rounded-full p-1 flex items-center">
        <button 
          onClick={() => setActiveCategory('photos')}
          className={`flex items-center gap-2 py-2 px-4 rounded-full transition-all duration-300 ${activeCategory === 'photos' ? 'bg-navy-800 text-white' : 'text-elegant-700 hover:bg-elegant-200'}`}
        >
          <Camera size={16} />
          <span className="text-xs">Fotografia</span>
        </button>
        
        <button
          onClick={() => setActiveCategory('films')}
          className={`flex items-center gap-2 py-2 px-4 rounded-full transition-all duration-300 ${activeCategory === 'films' ? 'bg-navy-800 text-white' : 'text-elegant-700 hover:bg-elegant-200'}`}
        >
          <Film size={16} />
          <span className="text-xs">Film</span>
        </button>
      </div>
    </div>
  );
};

export default CategoryToggle;
